import { isRequired } from '@shared/utils/CustomErrors'

import config from '@shared/config'

import useBackend from '@shared/hooks/useBackend'

function softloginAPI() {
  // HOOKS
  const { setup, doPost } = useBackend()

  // INIT
  setup('/softlogin', config.microserviceBaseUrl)

  // METHODS
  async function verifyCustomerData({
    partnerNumber = isRequired('partnerNumber'),
    birthDate = isRequired('birthDate'),
    locale = isRequired(locale),
  }, passthrough) {
    const response = await doPost({
      url: `/v1/auth/dvp/sms/send`,
      data: {
        partnerNumber,
        birthDate,
        locale
      },
      passthrough
    })
    return response.data
  }

  async function verifyCustomerTAN({
    partnerNumber = isRequired('partnerNumber'),
    smsCode = isRequired('smsCode'),
  }, passthrough) {
    const response = await doPost({
      url: '/v1/auth/dvp/sms/verify',
      data: {
        partnerNumber,
        smsCode
      },
      passthrough
    })

    return response.data
  }

  return {
    verifyCustomerData,
    verifyCustomerTAN
  }
}

function softloginOvpv3API() {
  // HOOKS
  const { setup, doPost } = useBackend()

  // INIT
  setup('/ovpv3', config.microserviceBaseUrl)

  // METHODS
  async function createSoftloginBasket({
    token = isRequired('token'),
    channel = isRequired('channel')
  }, passthrough) {
    const response = await doPost({
      url: '/softlogin/baskets',
      data: {
        channel
      },
      config: {
        headers: {
          Authorization: `Bearer ${token}`
        },
      },
      passthrough
    })

    return response.data
  }

  return {
    createSoftloginBasket
  }
}

export default {
  ...softloginAPI(),
  ...softloginOvpv3API()
}
